<div class="mt-8">
  <div class="mb-4 p-4" *ngIf="!isLocked">
    <p class="mb-2">
      List your hemodialysis employers, starting with the most recent (Required for all certifications)
    </p>
    <p class="text-lg text-amber-400" *ngIf="licenseEmployers.length === 0">
      <mat-icon class="text-lg text-amber-400">info</mat-icon>
      At least one employer is required.
    </p>
  </div>

  <!-- Employer Form to Add New Employer -->
  <form [formGroup]="employerForm" #formDirective="ngForm" *ngIf="!isLocked">
    <div class="flex flex-col md:flex-row md:gap-4 items-center">
      <mat-form-field [ngClass]="employerForm.get('employerName')?.value === 'Other' ? '' : 'w-1/3'">
        <mat-label>Employer</mat-label>
        <mat-select formControlName="employerName">
          <mat-option *ngFor="let employer of employers" [value]="employer.employerName">
            {{ employer.employerName }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="employerForm.get('employerName')?.hasError('required')">
          Employer is required
        </mat-error>
      </mat-form-field>
      <mat-form-field *ngIf="employerForm.get('employerName')?.value === 'Other'">
        <mat-label>Employer Name</mat-label>
        <input matInput formControlName="otherName" placeholder="Enter employer name" (blur)="validateOtherName()">
        <mat-error *ngIf="employerForm.get('otherName')?.invalid">
          Employer name is required
        </mat-error>
      </mat-form-field>
      <mat-form-field *ngIf="employerForm.get('employerName')?.value === 'Other'">
        <mat-label>Employer Location</mat-label>
        <input matInput formControlName="otherLocation" placeholder="Enter employer location" (blur)="validateOtherLocation()">
        <mat-error *ngIf="employerForm.get('otherLocation')?.invalid">
          Employer location is required
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>From Date</mat-label>
        <input matInput formControlName="fromDate" [max]="sharedService.today" [matDatepicker]="pickerFrom" />
        <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
        <mat-datepicker #pickerFrom></mat-datepicker>
        <mat-error *ngIf="employerForm.get('fromDate')?.hasError('required')">
          From date is required
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>To Date</mat-label>
        <input matInput formControlName="toDate" [max]="sharedService.today" [matDatepicker]="pickerTo" />
        <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
        <mat-datepicker #pickerTo></mat-datepicker>
      </mat-form-field>
      <button mat-raised-button (click)="addEmployer()" color="primary" [disabled]="employerForm.invalid">
        Add Employer
      </button>
    </div>
  </form>
</div>

<div class="employment-history-container mt-6">
  <h1 class="mb-4">Employment History</h1>
  <form [formGroup]="editEmployerForm">
    <mat-table [dataSource]="dataSource" matSort #addressSort="matSort" aria-label="addresses" class="portal-table">
      <ng-container matColumnDef="employerName">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">Employer Name</mat-header-cell>
        <mat-cell *matCellDef="let employer; let i = index">
          <div *ngIf="editingIndex !== i || employer.employerName !== 'Other'">
            <span class="mobile-label">Employer</span>
            {{ employer.employerName !== 'Other' ? employer.employerName : employer.otherName }}
          </div>
          <div *ngIf="editingIndex === i && employer.employerName === 'Other'">
            <mat-form-field class="-mb-4 mt-2" *ngIf="editEmployerForm.get('employerName')?.value === 'Other'">
              <mat-label>Employer Name</mat-label>
              <input matInput formControlName="otherName" placeholder="Enter employer name" (blur)="validateOtherNameEdit()">
              <mat-error *ngIf="editEmployerForm.get('otherName')?.invalid">
                Employer name is required
              </mat-error>
            </mat-form-field>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="location">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">Location</mat-header-cell>
        <mat-cell *matCellDef="let employer; let i = index">
          <div *ngIf="editingIndex !== i || employer.employerName !== 'Other'">
            <span class="mobile-label">Location</span>
            {{ employer.location !== '' ? employer.location : employer.otherLocation }}
          </div>
          <div *ngIf="editingIndex === i && employer.employerName === 'Other'">
            <mat-form-field class="-mb-4 mt-2" *ngIf="editEmployerForm.get('employerName')?.value === 'Other'">
              <mat-label>Employer Location</mat-label>
              <input matInput formControlName="otherLocation" placeholder="Enter employer location" (blur)="validateOtherLocationEdit()">
              <mat-error *ngIf="editEmployerForm.get('otherLocation')?.invalid">
                Employer location is required
              </mat-error>
            </mat-form-field>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="fromDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">From Date</mat-header-cell>
        <mat-cell *matCellDef="let employer; let i = index">
          <div *ngIf="editingIndex !== i">
            <span class="mobile-label">From Date</span>
            {{ employer.fromDate | date }}
          </div>
          <div *ngIf="editingIndex === i">
            <mat-form-field class="-mb-4 mt-2">
              <mat-label>From Date</mat-label>
              <input matInput formControlName="fromDate" [max]="sharedService.today" [matDatepicker]="pickerFrom" />
              <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
              <mat-datepicker #pickerFrom></mat-datepicker>
              <mat-error *ngIf="editEmployerForm.get('fromDate')?.hasError('required')">
                From date is required
              </mat-error>
            </mat-form-field>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="toDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">To Date</mat-header-cell>
        <mat-cell *matCellDef="let employer; let i = index">
          <div *ngIf="editingIndex !== i">
            <span class="mobile-label">To Date</span>
            {{ employer.toDate | date }}
          </div>
          <div *ngIf="editingIndex === i">
            <mat-form-field class="-mb-4 mt-2">
              <mat-label>To Date</mat-label>
              <input matInput formControlName="toDate" [max]="sharedService.today" [matDatepicker]="pickerTo" />
              <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
              <mat-datepicker #pickerTo></mat-datepicker>
            </mat-form-field>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">Actions</mat-header-cell>
        <mat-cell *matCellDef="let employer; let i = index">
          <span class="mobile-label">Actions</span>
          <div class="flex flex-col md:flex-row md:gap-4" *ngIf="!isLocked && (!isRenewal || !employer.toDate) && editingIndex !== i">
            <button mat-icon-button color="primary" matTooltip="Edit Employer"
                    matTooltipPosition="below" [matTooltipShowDelay]="500" (click)="editEmployer(employer, i)">
              <mat-icon>edit</mat-icon>
            </button>
            <button *ngIf="!isLocked && !isRenewal" mat-icon-button color="warn" matTooltip="Delete Employer"
                    matTooltipPosition="below" [matTooltipShowDelay]="500" (click)="deleteEmployer(employer)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
          <div class="flex flex-col md:flex-row md:gap-4" *ngIf="editingIndex === i">
            <button mat-icon-button color="primary" matTooltip="Save Employer"
                    matTooltipPosition="below" [matTooltipShowDelay]="500" (click)="saveEmployer()"><mat-icon>save</mat-icon></button>
            <button mat-icon-button color="warn" matTooltip="Cancel Edit"
                    matTooltipPosition="below" [matTooltipShowDelay]="500" (click)="cancelEdit()">
              <mat-icon>cancel</mat-icon>
            </button>
          </div>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"
               class="portal-interactive-row" ></mat-row>
    </mat-table>
  </form>
</div>
